export class TrackVehicle {
  vehicleId: string;
  provider: string;
  routeId: string;
}
